import { render, staticRenderFns } from "./TaskDueDateChangedNotification.vue?vue&type=template&id=d13bfa48"
import script from "./TaskDueDateChangedNotification.vue?vue&type=script&lang=js"
export * from "./TaskDueDateChangedNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports